// import package
import axios from 'axios';

// import lib
import config from '../lib/config';

// import constant
import {
    SET_CURRENT_USER
} from '../constant';
import { DecryptData, EncryptData, GetToken, SetToken, axiosFunc, deleteToken, isEmpty } from './commonFunction';
import { Account_Connect } from './redux/action';
import { useAsyncError } from 'react-router-dom';

const AppenData = (data) => {
    var formdata = new FormData()
    var SendDta = Object.entries(data).map((item) => {
        if (Array.isArray(item[1])) {
            var come = item[1].map(data => {
                if (data?.type && data?.size) {
                    //file
                    formdata.append(item[0], data)
                }
                else {
                    formdata.append(item[0], EncryptData(data))
  
                }
                return formdata
            })
            return come
  
        }
        else {
            if (item[1]?.type && item[1]?.size) {
                //file type
                formdata.append(item[0], item[1])
            }
            else {
                formdata.append(item[0], EncryptData(item[1]))
  
            }
            return formdata
        }
    })
    return SendDta
  }


export const gettokencount = async (token, dispatch) => {
    
    try {
        let respData = await axiosFunc({
            'method': 'get',
            'url': `${config.API}/admin/panel/gettokencount`,
            'headers': {
                'Authorization': sessionStorage.admin_token
            },
        });
        return {
            loading: false,
            userValue: respData.data
        }
    }
    catch (err) {
        return {
            loading: false,
            error: err?.response?.data?.errors
        }
    }
}
export const getbidderscount = async (token, dispatch) => {
    
    try {
        let respData = await axiosFunc({
            'method': 'get',
            'url': `${config.API}/admin/panel/getbidderscount`,
            'headers': {
                'Authorization': sessionStorage.admin_token
            },
        });
        return {
            loading: false,
            userValue: respData.data.countData
        }
    }
    catch (err) {
        return {
            loading: false,
            error: err?.response?.data?.errors
        }
    }
}
export const getemailTemplate = async (id, dispatch) => {
    
    try {
        let respData = await axiosFunc({
            'method': 'get',
            'url': `${config.API}/admin/panel/getemailTemplate/`+id,
            'headers': {
                'Authorization': localStorage.user_token
            },
        });

        
        return {
            loading: false,
            userValue: respData.data.userValue
        }
    }
    catch (err) {
        return {
            loading: false,
            error: err.response.data.errors
        }
    }
}
export const getemailTemplateList = async (token, dispatch) => {
    
    try {
        let respData = await axiosFunc({
            'method': 'get',
            'url': `${config.API}/admin/panel/getemailTemplateList`,
        });

        

        return {
            loading: false,
            userValue: respData.data.userValue
        }
    }
    catch (err) {
        return {
            loading: false,
            error: err.response.data.errors
        }
    }
}
export const updateEmailTemplate = async (data) => {
    try {
        let respData = await axiosFunc({
            'method': 'post',
            'url': `${config.API}/admin/panel/updateEmailTemplate`,
            data
        });      

        
        return {
            loading: false,
            result:respData.data.message
        }

    }
    catch (err) {
        return {
            loading: false,
            error: err.response.data.errors
        }
    }
}
export const updateSettings = async (data) => {
    
    try {
        let respData = await axiosFunc({
            'method': 'post',
            'url': `${config.API}/admin/panel/updateSettings`,
            data
        });
        return {
            loading: false,
        }

    }
    catch (err) {
        return {
            loading: false,
            error: err.response.data.errors
        }
    }
}

export const adminaccept = async (data, dispatch) => {
    try {
        let respData = await axiosFunc({
            'method': 'post',
            'url': `${config.API}/admin/panel/adminaccept/`,
            'headers': {
                'Authorization': localStorage.user_token
            },
            data

        });
        
        return {
            loading: false,
            result: respData.data
        }
    }
    catch (err) {
        return {
            loading: false,
            error: err.response.data.errors
        }
    }
}

export const adminreject = async (data, dispatch) => {
    try {
        let respData = await axiosFunc({
            'method': 'post',
            'url': `${config.API}/admin/panel/adminreject/`,
            'headers': {
                'Authorization': localStorage.user_token
            },
            data

        });
        return {
            loading: false,
            result: respData.data
        }
    }
    catch (err) {
        return {
            loading: false,
            error: err.response.data.errors
        }
    }
}

export const updatecms1 = async (data) => {
    try {
        let respData = await axiosFunc({
            'method': 'post',
            'url': `${config.API}/admin/panel/updatecms1`,
            data
        });

        return {
            loading: false,
        }

    }
    catch (err) {
        return {
            loading: false,
            error: err.response.data.errors
        }
    }
}

export const addcategory = async (data) => {
    try {
        // let bodyFormData = new FormData();
        // bodyFormData.append('name', data.name);
        // bodyFormData.append('image', data.image);
        // bodyFormData.append('subcategory',data.subcategory)

        let bodyFormData = AppenData(data)

        let respData = await axiosFunc({
            'method': 'post',
            'url': `${config.API}/admin/panel/addcategory`,
            headers: {
                'Content-Type': 'multipart/form-data',
            },
            data: bodyFormData[0],
        });
        return {
            loading: false,
        }

    }
    catch (err) {
        return {
            loading: false,
            error: err.response.data.errors
        }
    }
}

export const addtoken = async (data) => {
    
    try {

        // let bodyFormData = new FormData();
        // bodyFormData.append('name', data.name);
        // bodyFormData.append('tokencount', data.tokencount);
        // bodyFormData.append('price', data.price);
        // bodyFormData.append('tokenroyality', data.tokenroyality);
        // bodyFormData.append('tokendesc', data.tokendesc);
        // bodyFormData.append('Photofile', data.Photofile);

        let bodyFormData = AppenData(data)

        let respData = await axiosFunc({
            'method': 'post',
            'url': `${config.API}/admin/panel/addtoken`,
            headers: {
                'Content-Type': 'multipart/form-data',
                'Authorization': sessionStorage.admin_token
            },
            data: bodyFormData[0]
        });
        return {
            loading: false,
        }

    }
    catch (err) {
        return {
            loading: false,
            error: err.response.data.errors
        }
    }
}

export const getSubscriberList = async (data, dispatch) => {
    
    try {
        let respData = await axiosFunc({
            'method': 'get',
            'url': `${config.API}/admin/panel/getSubscriberList`,
            params: data
        });
        return {
            loading: false,
            userValue: respData.data
        }
    }
    catch (err) {
        return {
            loading: false,
            error: err
        }
    }
}

export const sendSubscriberMail = async (data) => {
    try { 
        let respData = await axiosFunc({
            'method': 'post',
            'url': `${config.API}/admin/panel/sendSubscribeMail`,
            data
        });

        return {
            loading: false,
            data : respData
        }
    }catch (error) {
        return {
            loading: false,
            error : error
        }
    }
}


export const updateSubscriberStatus = async (data) => {
    try {
        let respData = await axiosFunc({
            'method': 'post',
            'url': `${config.API}/admin/panel/subscriberStatus`,
            data: data
        });
        return {
            loading: false,
            userValue: respData.data
        }
    }
    catch (err) {
        return {
            loading: false,
            error: err.response.data.errors
        }
    }
}

export const deleteSubscriber = async (data) => {
    try {
        let respData = await axiosFunc({
            'method': 'post',
            'url': `${config.API}/admin/panel/deleteSubcriber`,
            data: data
        });
        return {
            loading: false,
            userValue: respData.data
        }
    }
    catch (err) {
        return {
            loading: false,
            error: err.response.data.errors
        }
    }
}




export const addVerifieddata = async (data) => {
    
    try {

        // let bodyFormData = new FormData();
        // bodyFormData.append('Rariblelinkprofile', data.Rariblelinkprofile);
        // bodyFormData.append('Ethereumwalletaddress', data.Ethereumwalletaddress);
        // bodyFormData.append('creator', data.creator);
        // bodyFormData.append('collector', data.collector);
        // bodyFormData.append('Tellusaboutyourself', data.Tellusaboutyourself);
        // bodyFormData.append('screenshotimage', data.screenshotimage);
        let bodyFormData = AppenData(data);
        let respData = await axiosFunc({
            'method': 'post',
            'url': `${config.API}/admin/panel/addVerfieddata`,
            headers: {
                'Content-Type': 'multipart/form-data',
                'Authorization': sessionStorage.admin_token
            },
            data: bodyFormData[0]
        });
        return {
            loading: false,
        }

    }
    catch (err) {
        return {
            loading: false,
            error: err.response.data.errors
        }
    }
}
export const addcategorydet = async (data) => {
    
    try {
        // let bodyFormData = new FormData();
        // bodyFormData.append('categoryname', data.cname);
        // bodyFormData.append('tokenname', data.tname);
        // bodyFormData.append('Photofile', data.Photofile);

        let bodyFormData = AppenData(data)

        let respData = await axiosFunc({
            'method': 'post',
            'url': `${config.API}/admin/panel/addcategorydet`,
            headers: {
                'Content-Type': 'multipart/form-data',
                'Authorization': sessionStorage.admin_token
            },
            data: bodyFormData[0]
        });
        return {
            loading: false,
        }

    }
    catch (err) {
        return {
            loading: false,
            error: err.response.data.errors
        }
    }
}


export const getburntokenlist = async (filterData, dispatch) => {
    
    try {
        let respData = await axiosFunc({
            'method': 'get',
            'url': `${config.API}/admin/panel/getburntokenlist`,
            params: filterData
        });
        return {
            loading: false,
            userValue: respData.data.userValue

        }
        
    }

    catch (err) {

        return {
            loading: false,
            error: err.response.data.errors
        }
        
    }
}


export const getpromotion = async (filterData, dispatch) => {
    
    try {
        let respData = await axiosFunc({
            'method': 'get',
            'url': `${config.API}/admin/panel/getpromotion`,
            params: filterData
        });
     
        return {
            loading: false,
            userValue: respData.data.userValue

        }
        
    }

    catch (err) {

        return {
            loading: false,
            error: err?.response?.data?.errors
        }
        
    }
}

export const gettokenlist = async (filterData, dispatch) => {
    
    try {
        let respData = await axiosFunc({
            'method': 'get',
            'url': `${config.API}/admin/panel/gettokenlist`,
            params: filterData
        });
        return {
            loading: false,
            userValue: respData.data.userValue

        }
        
    }

    catch (err) {

        return {
            loading: false,
            error: err.response.data.errors
        }
        
    }
}
//Preethi getverfiedlist
export const GetVerifiedList = async (filterData, dispatch) => {
    
    try {
        let respData = await axiosFunc({
            'method': 'get',
            'url': `${config.API}/admin/panel/getverifiedlist`,
            params: filterData
        });
        return {
            loading: false,
            userValue: respData.data.userValue

        }
        
    }

    catch (err) {

        return {
            loading: false,
            error: err.response.data.errors
        }
        
    }
}
//Pretthi userslist
export const getuserslist = async (data) => {
    
    try {
        let respData = await axiosFunc({
            'method': 'get',
            'url': `${config.API}/admin/panel/getuserslist`,
            params : data
        });
        
        return respData?.data
        
    }
    catch (err) {

        return {
            loading: false,
            error: err.response.data.errors
        }
    }
}

export const updatecategory = async (data) => {
    
    try {
        
        // let bodyFormData = new FormData();
        // bodyFormData.append('name', data.name);
        // bodyFormData.append('Photofile', data.Photofile);
        // bodyFormData.append('userId', data.userId);

        let bodyFormData = AppenData(data)

        
        let respData = await axiosFunc({
            'method': 'post',
            'url': `${config.API}/admin/panel/updatecategory`,
            headers: {
                'Content-Type': 'multipart/form-data',
                'Authorization': sessionStorage.admin_token
            },
            data: bodyFormData[0]
        });
        return {
            loading: false,
        }

    }
    catch (err) {
        return {
            loading: false,
            error: err.response.data.errors
        }
    }
}

export const adduser = async (data) => {
    
    try {
        // let bodyFormData = new FormData();
        // bodyFormData.append('name', data.name);
        // bodyFormData.append('email', data.email);
        // bodyFormData.append('phonenumber', data.phonenumber);
        // bodyFormData.append('address1', data.address1);
        // bodyFormData.append('address2', data.address2);
        // bodyFormData.append('pincode', data.pincode);
        // bodyFormData.append('city', data.city);
        // bodyFormData.append('country', data.country);
        // bodyFormData.append('Photofile', data.Photofile);

        let bodyFormData = AppenData(data)

        let respData = await axiosFunc({
            'method': 'post',
            'url': `${config.API}/admin/panel/adduser`,
            headers: {
                'Content-Type': 'multipart/form-data',
                'Authorization': sessionStorage.admin_token
            },
            data: bodyFormData
        });
        return {
            loading: false,
        }

    }
    catch (err) {
        return {
            loading: false,
            error: err.response.data.errors
        }
    }
}

export const addfaq = async (data) => {
    try {
        let respData = await axiosFunc({
            'method': 'post',
            'url': `${config.API}/admin/panel/addfaq`,
            data
        });
        
        // return {
        //     loading: false,
        // }

        return respData?.data

    }
    catch (err) {
        console.error("🚀 ~ addfaq ~ err:", err)
        return {
            loading: false,
            error: err.response.data.errors
        }
    }
}

export const updatefaq = async (data) => {
    
    try {

        let respData = await axiosFunc({
            'method': 'post',
            'url': `${config.API}/admin/panel/updatefaq`,

            data
        });

        // return {
        //     loading: false,
        // }
        return respData?.data;

    }
    catch (err) {
        console.error("updatefaq_err", err,err.response.data)
        return {
            loading: false,
            error: err.response.data.errors
        }
    }
}

export const login = async (data) => {
    try {
        let respData = await axiosFunc({
            'method': 'post',
            'url': `${config.API}/admin/panel/login`,
            data
        });
        if(respData?.data?.token){
            sessionStorage.setItem('admin_token', respData?.data?.token);
            SetToken(config.adminCookieName,respData?.data?.token?.split(" ")?.[1])
        }

        return {
            loading: false,
            result: respData?.data?.result,
            error: respData?.data?.error,
            token: respData?.data?.token?.split(" ")?.[1],
        }

    }
    catch (err) {
        console.error('login_error',err)
        return {
            loading: false,
            error: err.response.data.errors
        }
    }
}



export const getBalance = async (id, dispatch) => {
    //
    try {
        let respData = await axiosFunc({
            'method': 'get',
            'url': `${config.API}/admin/panel/getBalance/`,
        });
        return {
            loading: false,
            userValue: respData.data.userValue
        }
    }
    catch (err) {
        return {
            loading: false,
            error: err.response.data.errors
        }
    }
}



export const updateWithdraw = async (data, dispatch) => {
    
    try {
        let respData = await axiosFunc({
            'method': 'post',
            'url': `${config.API}/admin/panel/updateWithdraw`,
            data
        });
        return {
            loading: false,
            userValue: respData.data.userValue
        }
    }
    catch (err) {
        return {
            loading: false,
            error: err.response.data.errors
        }
    }
}

export const getuser = async (id, dispatch) => {
    //
    try {
        let respData = await axiosFunc({
            'method': 'get',
            'url': `${config.API}/admin/panel/getuser/` + id,
            'headers': {
                'Authorization': sessionStorage.admin_token
            },
        });
        
        return {
            loading: false,
            userValue: respData.data.userValue
        }
    }
    catch (err) {
        return {
            loading: false,
            error: err.response.data.errors
        }
    }
}

export const getfaq = async (id, dispatch) => {
    //
    try {
        let respData = await axiosFunc({
            'method': 'get',
            'url': `${config.API}/admin/panel/getfaq/` + id,
            'headers': {
                'Authorization': sessionStorage.admin_token
            },
        });
        return {
            loading: false,
            userValue: respData.data.userValue
        }
    }
    catch (err) {
        return {
            loading: false,
            error: err.response.data.errors
        }
    }
}



export const getcms1 = async (id, dispatch) => {
    //
    try {
        let respData = await axiosFunc({
            'method': 'get',
            'url': `${config.API}/admin/panel/getcms1/` + id,
            'headers': {
                'Authorization': sessionStorage.admin_token
            },
        });
        return {
            loading: false,
            userValue: respData.data.userValue
        }
    }
    catch (err) {
        return {
            loading: false,
            error: err.response.data.errors
        }
    }
}


export const getReportView = async (id) => {
   
    try {
        let respData = await axiosFunc({
            'method': 'get',
            'url': `${config.API}/admin/panel/getReportView/` + id,
           
        });
        
        return {
            loading: false,
            userValue: respData.data
        }
    }
    catch (err) {
        return {
            loading: false,
            error: err.response.data.errors
        }
    }
}

export const deletepair = async (id, dispatch) => {
    //;
    try {
        let respData = await axiosFunc({
            'method': 'put',
            'url': `${config.API}/admin/panel/deletepair/` + id,
            'headers': {
                'Authorization': sessionStorage.admin_token
            },
        });
        return {
            loading: false,
            userValue: respData.data.userValue
        }
    }
    catch (err) {
        return {
            loading: false,
            error: err.response.data.errors
        }
    }
}

export const deletecategory = async (id, dispatch) => {
    
    try {
        let respData = await axiosFunc({
            'method': 'post',
            'url': `${config.API}/admin/panel/deletecategorys/` + id,
            'headers': {
                'Authorization': sessionStorage.admin_token
            },
        });
        return {
            loading: false,
            userValue: respData.data.userValue
        }
    }
    catch (err) {
        return {
            loading: false,
            error: err.response.data.errors
        }
    }

}

export const deletegetVerfied = async (id, dispatch) => {
    
    try {
        let respData = await axiosFunc({
            'method': 'put',
            'url': `${config.API}/admin/panel/deletegetVerfied/` + id,
            'headers': {
                'Authorization': sessionStorage.admin_token
            },
        });
        return {
            loading: false,
            userValue: respData.data.userValue
        }
    }
    catch (err) {
        return {
            loading: false,
            error: err.response.data.errors
        }
    }
}

export const getCmsList = async (token, dispatch) => {
    
    try {
        let respData = await axiosFunc({
            'method': 'get',
            'url': `${config.API}/admin/panel/getCmsList`,
        });

        

        return {
            loading: false,
            cmsData: respData.data.cmsData
        }
    }
    catch (err) {
        return {
            loading: false,
            error: err.response.data.errors
        }
    }
}
export const getCmsData = async (id) => {
    
    try {
        let respData = await axiosFunc({
            'method': 'get',
            'url': `${config.API}/admin/panel/getCmsData/` + id,
        });

        

        return {
            loading: false,
            cmsData: respData.data.cmsData
        }
    }
    catch (err) {
        return {
            loading: false,
            error: err.response.data.errors
        }
    }
}
export const updateCmsData = async (data) => {
    try {
        let bodyFormData = AppenData(data);
        let respData = await axiosFunc({
            'method': 'post',
            'url': `${config.API}/admin/panel/updateCmsData`,
            headers: {
                'Content-Type': 'multipart/form-data',
            },
            data : bodyFormData[0],
        });

        
        return respData.data

    }
    catch (err) {
        return {
            loading: false,
            error: err.response.data.errors
        }
    }
}

export const adminReplay = async (data, id) => {
    
    try {
        let respData = await axiosFunc({
            'method': 'post',
            'url': `${config.API}/admin/panel/adminReplay/` + id,
            data
        });
        return {
            data: respData.data.message
        }
    }
    catch (err) {
        return {
            loading: false,
            error: err.response.data.errors
        }
    }
}
export const deletesupportchat = async (id, data, dispatch) => {

    try {
        let respData = await axiosFunc({
            'method': 'put',
            'url': `${config.API}/admin/panel/deletesupportchat/` + id,
            'headers': {
                'Authorization': sessionStorage.admin_token
            },
            data: data
        });
        return {
            loading: false,
            userValue: respData.data.userValue
        }
    }
    catch (err) {
        return {
            loading: false,
            error: err.response.data.errors
        }
    }
}
export const getChats = async (id) => {
    
    try {
        let respData = await axiosFunc({
            'method': 'get',
            'url': `${config.API}/admin/panel/getChats/` + id,
        });
        return {
            getChats: respData.data.ticketDatas[0].reply,
            ticket_id: respData.data.ticketDatas[0]._id
        }
    }
    catch (err) {
        return {
            loading: false,
            error: err.response.data.errors
        }
    }
}
export const deletesupport = async (id, dispatch) => {
    //;
    try {
        let respData = await axiosFunc({
            'method': 'put',
            'url': `${config.API}/admin/panel/deletesupport/` + id,
            'headers': {
                'Authorization': sessionStorage.admin_token
            },
        });
        return {
            loading: false,
            userValue: respData.data.userValue
        }
    }
    catch (err) {
        return {
            loading: false,
            error: err.response.data.errors
        }
    }
}
export const getSupportList = async (token, dispatch) => {
    
    try {
        let respData = await axiosFunc({
            'method': 'get',
            'url': `${config.API}/admin/panel/getSupportList`,
        });
        
        return {
            loading: false,
            supportDetails: respData.data.supportData
        }
    }
    catch (err) {
        return {
            loading: false,
            error: err.response.data.errors
        }
    }
}

export const deletfaq = async (id, dispatch) => {
    //;
    try {
        let respData = await axiosFunc({
            'method': 'put',
            'url': `${config.API}/admin/panel/deletefaq/` + id,
            'headers': {
                'Authorization': sessionStorage.admin_token
            },
        });
        return {
            loading: false,
            userValue: respData.data.userValue
        }
    }
    catch (err) {
        return {
            loading: false,
            error: err.response.data.errors
        }
    }
}

export const getcount = async (token, dispatch) => {
    
    try {
        let respData = await axiosFunc({
            'method': 'get',
            'url': `${config.API}/admin/panel/getcount`,
            'headers': {
                'Authorization': sessionStorage.admin_token
            },
        });
        return {
            loading: false,
            userValue: respData.data.userValue
        }
    }
    catch (err) {
        return {
            loading: false,
            error: err.response.data.errors
        }
    }
}

export const getuserdata = async (token, dispatch) => {
    
    try {
        let respData = await axiosFunc({
            'method': 'get',
            'url': `${config.API}/admin/panel/getuserdata`,
            'headers': {
                'Authorization': sessionStorage.admin_token
            },
        });
        return {
            loading: false,
            userValue: respData.data.userValue
        }
    }
    catch (err) {
        return {
            loading: false,
            error: err.response.data.errors
        }
    }
}

//added
export const gettokendata = async (id) => {
    
    try {
        let respData = await axiosFunc({
            'method': 'get',
            'url': `${config.API}/admin/panel/gettokendata/` + id.tokenOwner+'/'+id.tokenCounts,
        });

        

        return {
            loading: false,
            cmsData: respData.data.userValue
        }
    }
    catch (err) {
        return {
            loading: false,
            error: err.response.data.errors
        }
    }
}

export const getcatorylist = async (filterData, dispatch) => {
    
    try {
        let respData = await axiosFunc({
            'method': 'get',
            'url': `${config.API}/admin/panel/getcatorylist`,
            params: filterData
        });
        return {
            loading: false,
            userValue: respData.data.userValue
        }
    }
    catch (err) {
        return {
            loading: false,
            error: err.response.data.errors
        }
    }
}
export const getcatory = async (filterData, dispatch) => {
    
    try {
        let respData = await axiosFunc({
            'method': 'get',
            'url': `${config.API}/admin/panel/getcatory`,
            params: filterData
        });
        return {
            loading: false,
            userValue: respData.data.userValue
        }
    }
    catch (err) {
        return {
            loading: false,
            error: err.response.data.errors
        }
    }
}

export const getfaqlist = async (data, dispatch) => {
    
    try {
        let respData = await axiosFunc({
            'method': 'get',
            'url': `${config.API}/admin/panel/getfaqlist`,
            params: data
        });
        return {
            loading: false,
            userValue: respData.data.userValue
        }
    }
    catch (err) {
        return {
            loading: false,
            error: err.response.data.errors
        }
    }
}


export const getCurrentUser = async (token, dispatch) => {
    try {
        let respData = await axiosFunc({
            'method': 'get',
            'url': `${config.API.userService}/api/currentUser`,
            'headers': {
                'Authorization': token
            },
        });
        dispatch(setCurrentUser(respData.data.result))
        return true
    }
    catch (err) {
        return false
    }
}

export const setCurrentUser = decoded => {
    return {
        type: Account_Connect,
        Account_Detail: decoded
    };
};

export const forgotPassword = async (data) => {
    try {
        let respData = await axiosFunc({
            'method': 'post',
            'url': `${config.API}/admin/panel/forgotPassword`,
            data
        });

        return {
            loading: false,
        }
    }
    catch (err) {
        return {
            loading: false,
            error: err.response.data.errors
        }
    }
}


export const changePassword = async (data) => {
    try {
        let respData = await axiosFunc({
            'method': 'put',
            'url': `${config.API}/admin/panel/forgotPassword`,
            data
        });

        return {
            loading: false,
        }
    }
    catch (err) {
        return {
            loading: false,
            error: err.response.data.errors
        }
    }
}

export const logout = (history) => {
    localStorage.removeItem('admin_token');
    deleteToken(config.adminCookieName)
    history.push('/Login')
}

export const resetPassword = async (data) => {
    try {
        let respData = await axiosFunc({
            'method': 'put',
            'url': `${config.API}/admin/panel/resetPassword`,
            headers: {
                'Authorization': sessionStorage.admin_token
            },
            data
        });

        return {
            loading: false,
        }
    }
    catch (err) {
        return {
            loading: false,
            error: err.response.data.errors
        }
    }
}

export const getreportlist = async (data, dispatch) => {
    
    try {
        let respData = await axiosFunc({
            'method': 'get',
            'url': `${config.API}/admin/panel/getreportlist`,
            params : data
        });
        
        return respData?.data;
    }
    catch (err) {
        console.error("🚀 ~ getreportlist ~ err:", err)
        return {
            loading: false,
            error: err.response.data.errors
        }
    }
}


export const BurnField = async (data) => {
    
    try {
      
          let respData = await axiosFunc({
            'method': 'post',
            'url': `${config.API}/admin/panel/BurnField`,
          
            data: data
        });
        return {
            loading: false,
        }

    }
    catch (err) {
        return {
            loading: false,
            error: err.response.data.errors
        }
    }
}

export const getCMSlist = async (data, dispatch) => {
    
    try {
        let respData = await axiosFunc({
            'method': 'get',
            'url': `${config.API}/admin/panel/getCMSlist1`,
            params: data
        });
        return {
            loading: false,
            userValue: respData.data.userValue
        }
    }
    catch (err) {
        return {
            loading: false,
            error: err.response.data.errors
        }
    }
}

export const getadminuserdata = async (payload) => {
    try {
        
        let respData = await axiosFunc({
            'method': 'post',
            'url': `${config.API}/admin/panel/getAdminData/`,
            'data' : payload
        });
        
        return {
            success : true,
            adminData : respData.data
        }
    }catch (error) {
        
        return {
            success : false,
            error : error
        }
    }
}

export const updateAdminProfile = async (payload) => {
    try {
        
        let respData = await axiosFunc({
            'method': 'post',
            'url': `${config.API}/admin/panel/updateAdmin/`,
            'data' : payload,
        });
        return {
            loading: false,
            microValue: respData
        }
    }catch(error) {
        return {
            loading: false,
            microValue: error
        }
    }
}


export const deleteStatus = async (payload) => {
    try {
        
        let respData = await axiosFunc({
            'method': 'post',
            'url': `${config.API}/admin/panel/deleteStatus/`,
            'data' : payload,
        });
        return {
            loading: false,
            userValue: respData
        }
    }catch(error) {
        return {
            loading: false,
            // microValue: error
        }
    }
}

export const setactivateUserAction = async (data) => {
    try {
        let respData = await axiosFunc({
            'method': 'post',
            'url': `${config.API}/admin/panel/setActivateUser`,
            data
        });
        return {
            loading : false,
            data : respData.data
        }
    }catch(error) {
        return {
            loading : false,
            error : error
        }
    }
}



export const AdminPriceChange = async (data) => {
    
    try {
        let respData = await axiosFunc({
            'method': 'post',
            'url': `${config.API}/admin/panel/AdminPriceChange`,
            'data' : data
        });
        return {
            // loading : false,
            data : respData.data
        }
    }catch(error) {
        return {
            // loading : false,
            error : error
        }
    }
}

export const AdminDataPrice = async () => {

    try {
        let respData = await axiosFunc({
            'method': 'get',
            'url': `${config.API}/admin/panel/AdminPriceChangeAdmin`,
        });
        
        return {

            // loading : false,
            data : respData.data
        }
    }catch(error) {
        return {
            // loading : false,
            error : error
        }
    }
}

export const Subcategory = async (data) => {

    try {
        // let bodyFormData = new FormData();
        // bodyFormData.append('name', data.name);
        // bodyFormData.append('image', data.image);
        // bodyFormData.append('subcategory',JSON.stringify(data.subcategory))
        // bodyFormData.append('_id',data._id)
        // bodyFormData.append('action',data.action)

        let bodyFormData = AppenData(data);

        let respData = await axiosFunc({
            'method': 'post',
            'url': `${config.API}/admin/panel/subcategory`,
            headers: {
                'Content-Type': 'multipart/form-data',
            },
            data : bodyFormData[0],
        });
        
        return {

            // loading : false,
            data : respData.data
        }
    }catch(error) {
        return {
            // loading : false,
            error : error
        }
    }
}


export const addnewpromotion = async (data) => {

    try {
        // var formData = new FormData();
        // if (data.image) { formData.append('image', data.image) }
        let bodyFormData = AppenData(data);
        let respData = await axiosFunc({
            'method': 'post',
            'url': `${config.API}/admin/panel/addnewpromotion`,
            headers: {
                'Content-Type': 'multipart/form-data',
            },
            data : bodyFormData[0],
        });
        
        return respData.data;
    }
    catch(error) {
        return {
            // loading : false,
            error : error
        }
    }
}

export const getnewpromotion = async () => {
    try {
        
        let respData = await axiosFunc({
            'method': 'post',
            'url': `${config.API}/admin/panel/getnewpromotion`,
        });
        return {
            data : respData.data
        }
    }catch(error) {
        return {
            error : error
        }
    }
}

export const VideoTest = async (file) => {

    try {
        var formData = new FormData();
        if (file) { formData.append('video', file) }
        let respData = await axiosFunc({
            'method': 'post',
            'url': `${config.API}/admin/panel/videotest`,
            data:formData,
        });
        
        return {

            // loading : false,
            data : respData.data
        }
    }catch(error) {
        return {
            // loading : false,
            error : error
        }
    }
}

export const CollectionPromotionAction = async(data) => {
    try {
        let respData = await axiosFunc({
            'method': 'post',
            'url': `${config.API}/admin/panel/collectionpromotion`,
            headers: {
                'Authorization': sessionStorage.admin_token
            },
            data:data,
        });
        
        return respData.data;
    }
    catch(error) {
        console.error('CollectionPromotionAction_error',error)
        return {
            // loading : false,
            error : error
        }
    }
}

export const getSupportTickets = async () => {
    try {
        let respData = await axiosFunc({
            'method': 'get',
            'url': `${config.API}/admin/panel/getSupportTicket`,
            headers: {
                'Authorization': sessionStorage.admin_token
            },
        });
        return respData.data;
    } 
    catch (e) {
        console.error('getSupportTickets_error', e)
        return {
            error: e
        }
    }
}

export const replayTickets = async (data) => {
    try {
        let respData = await axiosFunc({
            'method': 'post',
            'url': `${config.API}/admin/panel/replaySupportTicket`,
            headers: {
                'Authorization': sessionStorage.admin_token
            },
            data: data
        });
        return respData.data;
    } 
    catch (e) {
        console.error('replayTickets_error', e)
        return {
            error: e
        }
    }
}







export const addannouncement = async (data) => {

    try{
        
        let respData = await axiosFunc({
            'method': 'post',
            'url': `${config.API}/admin/panel/addannouncement`,
            'headers': {
                'Authorization': sessionStorage.admin_token
            },
            data
        });
        
        if(respData.status == 200 && respData.data.status == true) {
            return {
                loading: false,
                result: respData.data.message
            }
        }
        if(respData.status == 200 && respData.data.status == false) {
            return {
                loading: false,
                error : respData.data.errors
            }
        }
    } 
    catch (err) {
        console.error("addannouncement_err", err)
    }
}

export const deleteannouncement = async (id, deleted) => {
    try {
        let data = { _id : id, deleted : deleted};
        let respData = await axiosFunc({
            'method': 'post',
            'url': `${config.API}/admin/panel/deleteannouncement`,
            'headers': {
                'Authorization': sessionStorage.admin_token
            },
            data
        });

        if(respData.status == 200) {
            return {
                loading: false,
                announcementdata : respData
            }
        }
      
    }
    catch (err) {
        return {
            loading: false,
            error: err.response.data.errors
        }
    }
}


export const getannouncementlist = async (data, dispatch) => {
    try {
        let respData = await axiosFunc({
            'method': 'get',
            'url': `${config.API}/admin/panel/getannouncementlist`,
            'headers': {
                'Authorization': sessionStorage.admin_token
            },
            params: data
        });
        return {
            loading: false,
            announcementdata : respData?.data?.data
        }

    }
    catch (err) {
        console.error("getannouncementlist_err", err)
        return {
            loading: false,  
        }
    }
}


export const getannouncementdata = async (id) => {

    try{
        let respData = await axiosFunc({
            'method': 'get',
            'url': `${config.API}/admin/panel/getannouncement/` + id,
            'headers': {
                'Authorization': sessionStorage.admin_token
            },
        });
        if(respData.status == 200) {
            return respData.data;
        }
    } 
    catch (err) {
        console.error("getannouncementdata_err", err)
    }
}


export const updateannouncement = async (data) => {
    try{
        let respData = await axiosFunc({
            'method': 'post',
            'url': `${config.API}/admin/panel/updateannouncement`,
            'headers': {
                'Authorization': sessionStorage.admin_token
            },

            data
        });

        if(respData.status == 200 && respData.data.status == true) {
            return {
                loading: false,
                result: respData.data.message
            }
        }

        if(respData.status == 200 && respData.data.status == false) {
            return {
                loading: false,
                error : respData.data.errors
            }
        }
    } catch (err) {
        console.error("updateannouncement_err", err)
    }
}

export const GetResource = async (data) => {
    try {
        let respData = await axiosFunc({
            'method': 'post',
            'url': `${config.API}/admin/panel/getresource`,
            data:data,
            'headers': {
                'Authorization': sessionStorage.admin_token
            },
        });
        return respData.data
    }
    catch (err) {
        return {
            loading: false,
            error: err.response.data.errors
        }
    }
}

export const UpdateResource = async (data) => {
    try {
        let respData = await axiosFunc({
            'method': 'post',
            'url': `${config.API}/admin/panel/updateresource`,
            data:data,
            'headers': {
                'Authorization': sessionStorage.admin_token
            },
        });
        return respData.data
    }
    catch (err) {
        return {
            loading: false,
            error: err.response.data.errors
        }
    }
}

export const ServiceFeeaction = async (data) => {
    
    try {
        let respData = await axiosFunc({
            'method': 'post',
            'url': `${config.API}/admin/panel/servicefeeaction`,
            data:data,
            'headers': {
                'Authorization': sessionStorage.admin_token
            },
        });
        return respData.data
    }
    catch (err) {
        return {
            loading: false,
            error: err.response.data.errors
        }
    }
}

export const loginCheck = async() => {
    let senddata = {
        method: "get",
        url: `${config.API}/admin/panel/authenticate`,
    };
    let Resp = await axiosFunc(senddata);
    return Resp.data;
}


export const getCurrencyList = async () => {

    try {
        var senddata = {

            'method': 'GET',
            'url': `${config.API}/admin/panel/currencylist`,
        }
        let response = await axiosFunc(senddata)
        return response?.data;
    }
    catch (err) { 
        console.error("err in getCurrencyList", err) 
    }
}

export const getCurrency = async (data) => {
    
    try {
        var senddata = {

            'method': 'POST',
            'url': `${config.API}/admin/panel/getcurrency`,
            data : data
        }
        let response = await axiosFunc(senddata)
        
        return response?.data;
    }
    catch (err) { 
        console.error("err in getCurrency", err) 
    }
}

export const customtokenfetch = async (data) => {
    try {
        const senddata = {
            'method': 'POST',
            'url': `${config.API}/admin/panel/tokenfetchapi`,
            "headers": {
                "Content-Type": 'application/json'
            },
            data : data

        }
        let resp = await axiosFunc(senddata);
        if (resp.data.token)
            localStorage.setItem("token", resp.data.token);
        return resp.data;
    }
    catch (err) {
        console.error("customtokenfetch_error", err)
    }
}

export const addTokenCall = async (data) => {
    
    try {
        var senddata = {
            "method": "POST",
            "url": `${config.API}/admin/panel/addtoken`,
            "headers": {
                "Content-Type": 'application/json'
            },
            "data": data,
        }

        let response = await axiosFunc(senddata);
        return response.data;
    }
    catch (err) {
        console.error('addTokenCall_error', err)
    }
}